import React from 'react'
import Marquee from "react-fast-marquee";

const Footer = () => {
    return (
        <div className='footerDiv flex centerflex flexcol vertcenter relative'>
            <span className='footer'>Baby Pixel Gator</span>
            <Marquee
                    className='footerText'
                    speed={50}
                    gradient={false}
                    >
                    <span> - Evolution is a must</span>
                    <span> - Evolution is a must</span>
                    <span> - Evolution is a must</span>
                    <span> - Evolution is a must</span>
                    <span> - Evolution is a must</span>


            </Marquee>
        </div>
    )
}

export default Footer
